import * as React from "react";
import {Component} from "react";
import {connect} from "react-redux";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import {IRootState} from "../../store";
import H from "history";
import MailroomReportDownloadCard from "./MailroomReportDownloadCard";
import {MessageBarType, PrimaryButton} from "office-ui-fabric-react";
import { openFileDownload} from "../../utils/Utils";
import Actions from "../../redux/Actions";

interface MailroomReportsPageProps {
    apiService: ApiService;
    history: H.History;
}

interface MailroomReportsPageState {
    downloading: boolean;
    timingAnalysisResults?: any;
    timingAnalysisTenantId?: string;
}

class MailroomReportsPage extends Component<MailroomReportsPageProps & DispatchProps,MailroomReportsPageState> {
    
    constructor(props: MailroomReportsPageProps & DispatchProps) {
        super(props);

        this.state = {
            downloading: false,
            timingAnalysisResults: undefined,
            timingAnalysisTenantId: undefined
        };
    }

    async componentDidMount(): Promise<void> {
    }

    async componentDidUpdate(prevProps: Readonly<MailroomReportsPageProps & DispatchProps>, prevState: any): Promise<void>
    {
        
    }
    
    downloadStrategyCsvExport = async () => {
        this.setState({ downloading: true });
        
        try
        {
            console.log("downloading strategy csv export");
            const response = await this.props.apiService.downloadMailroomStrategyCsvExport();
            await openFileDownload(response);
        }
        catch (e)
        {
            await this.props.dispatch(Actions.showMessageBar(`Error downloading strategy csv export : ${e}`, MessageBarType.error));
            console.error(e);
        }
        
        this.setState({ downloading: false });
    }
    
    downloadMailroomStrategyOptionAnalysisExport = async () => {
        this.setState({ downloading: true });

        try {
            console.log("downloading Mailroom Sub Strategy Analysis Export");
            const response = await this.props.apiService.downloadMailroomStrategyOptionAnalysisExport();
            await openFileDownload(response);
        }
        catch (e) {
            await this.props.dispatch(Actions.showMessageBar(`Error downloading Mailroom Strategy Option Analysis Export : ${e}`, MessageBarType.error));
            console.error(e);
        }

        this.setState({ downloading: false });
    }
    
    public render(): JSX.Element {
        return (
            <div className={"flex-column"}>
                <MailroomReportDownloadCard/>
                <div className={"card"}>
                    <div className={"card__header"}>
                        <span className={"card__title"}>
                            Generate and download exports
                        </span>
                    </div>
                    <div className={"card__content flex-row flex--justify-content-center"}>
                        <PrimaryButton text="Strategy breakdown per school csv" onClick={this.downloadStrategyCsvExport} disabled={this.state.downloading} style={{ marginLeft: '1rem' }} />
                        <PrimaryButton text="Strategy option analysis csv" onClick={this.downloadMailroomStrategyOptionAnalysisExport} disabled={this.state.downloading} style={{ marginLeft: '1rem' }} />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): MailroomReportsPageProps => {

        return {
            history: state.history,
            apiService: state.auth.apiService
        };

    }
)(MailroomReportsPage)